
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "FormAssignmentInterface": [
      "AdditionalFormAssignment",
      "EmbeddedFormAssignment"
    ],
    "IdAble": [
      "ActivityLog",
      "AiRequestLog",
      "AnalysisFilter",
      "ApiLog",
      "Asset",
      "AssetField",
      "AssetFieldTranslation",
      "AssetOption",
      "AssetOptionTranslation",
      "AssetTranslation",
      "Attachment",
      "CallAttempt",
      "CallTemplate",
      "CallTemplateTranslation",
      "Config",
      "ContactOption",
      "Country",
      "CrisisRoom",
      "CrisisRoomGuideline",
      "CrisisRoomTemplate",
      "CrisisRoomTemplateTranslation",
      "Currency",
      "Darksite",
      "DocumentFile",
      "EmailLog",
      "EmailTemplate",
      "EmailTemplateTranslation",
      "FieldOption",
      "FieldOptionTranslation",
      "Form",
      "FormField",
      "FormFieldAssignment",
      "FormFieldTranslation",
      "FormTranslation",
      "Guideline",
      "GuidelineTemplate",
      "GuidelineTemplateTranslation",
      "GuidelineTranslation",
      "Incident",
      "IncidentLocationNotification",
      "Instruction",
      "InstructionTranslation",
      "Language",
      "Location",
      "LocationAttribute",
      "LocationAttributeOption",
      "LocationAttributeOptionTranslation",
      "LocationAttributeTranslation",
      "LocationNotificationTemplate",
      "NewFeedEntry",
      "Notification",
      "NotificationList",
      "NotificationListTranslation",
      "NotificationTemplate",
      "OpeningDay",
      "OpeningDayTranslation",
      "PersonData",
      "PressData",
      "ProductData",
      "PushEndpoint",
      "Scenario",
      "ScenarioCategory",
      "ScenarioCategoryNotification",
      "ScenarioCategoryTranslation",
      "ScenarioNotification",
      "ScenarioTranslation",
      "SmsLog",
      "SmsTemplate",
      "SmsTemplateTranslation",
      "Source",
      "SourceTranslation",
      "Standby",
      "Status",
      "StatusTranslation",
      "Tag",
      "Task",
      "TaskGroup",
      "TaskTemplate",
      "TaskTemplateTranslation",
      "User",
      "UserGroup",
      "UserNotification",
      "UserNotificationSuppression",
      "VehicleData",
      "VoiceLog",
      "Watchlist",
      "Widget"
    ],
    "NotifiableInterface": [
      "Scenario",
      "ScenarioCategory"
    ],
    "PermissableInterface": [
      "Scenario",
      "ScenarioCategory"
    ],
    "ScenarioOrCategoryNotificationInterface": [
      "ScenarioCategoryNotification",
      "ScenarioNotification"
    ],
    "TemplateInterface": [
      "CallTemplate",
      "EmailTemplate",
      "SmsTemplate"
    ],
    "TemplateType": [
      "CallTemplate",
      "EmailTemplate",
      "SmsTemplate"
    ],
    "Translated": [
      "CallTemplate",
      "EmailTemplate",
      "FieldOption",
      "FormField",
      "Instruction",
      "Scenario",
      "ScenarioCategory",
      "SmsTemplate",
      "Status",
      "TaskTemplate"
    ],
    "Translation": [
      "CallTemplateTranslation",
      "EmailTemplateTranslation",
      "FieldOptionTranslation",
      "FormFieldTranslation",
      "InstructionTranslation",
      "ScenarioCategoryTranslation",
      "ScenarioTranslation",
      "SmsTemplateTranslation",
      "StatusTranslation",
      "TaskTemplateTranslation"
    ],
    "UserGroupPermissionInterface": [
      "ScenarioCategoryUserGroupPermission",
      "ScenarioUserGroupPermission"
    ],
    "UserPermissionInterface": [
      "ScenarioCategoryUserPermission",
      "ScenarioUserPermission"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "FormAssignmentInterface": [
      "AdditionalFormAssignment",
      "EmbeddedFormAssignment"
    ],
    "IdAble": [
      "ActivityLog",
      "AiRequestLog",
      "AnalysisFilter",
      "ApiLog",
      "Asset",
      "AssetField",
      "AssetFieldTranslation",
      "AssetOption",
      "AssetOptionTranslation",
      "AssetTranslation",
      "Attachment",
      "CallAttempt",
      "CallTemplate",
      "CallTemplateTranslation",
      "Config",
      "ContactOption",
      "Country",
      "CrisisRoom",
      "CrisisRoomGuideline",
      "CrisisRoomTemplate",
      "CrisisRoomTemplateTranslation",
      "Currency",
      "Darksite",
      "DocumentFile",
      "EmailLog",
      "EmailTemplate",
      "EmailTemplateTranslation",
      "FieldOption",
      "FieldOptionTranslation",
      "Form",
      "FormField",
      "FormFieldAssignment",
      "FormFieldTranslation",
      "FormTranslation",
      "Guideline",
      "GuidelineTemplate",
      "GuidelineTemplateTranslation",
      "GuidelineTranslation",
      "Incident",
      "IncidentLocationNotification",
      "Instruction",
      "InstructionTranslation",
      "Language",
      "Location",
      "LocationAttribute",
      "LocationAttributeOption",
      "LocationAttributeOptionTranslation",
      "LocationAttributeTranslation",
      "LocationNotificationTemplate",
      "NewFeedEntry",
      "Notification",
      "NotificationList",
      "NotificationListTranslation",
      "NotificationTemplate",
      "OpeningDay",
      "OpeningDayTranslation",
      "PersonData",
      "PressData",
      "ProductData",
      "PushEndpoint",
      "Scenario",
      "ScenarioCategory",
      "ScenarioCategoryNotification",
      "ScenarioCategoryTranslation",
      "ScenarioNotification",
      "ScenarioTranslation",
      "SmsLog",
      "SmsTemplate",
      "SmsTemplateTranslation",
      "Source",
      "SourceTranslation",
      "Standby",
      "Status",
      "StatusTranslation",
      "Tag",
      "Task",
      "TaskGroup",
      "TaskTemplate",
      "TaskTemplateTranslation",
      "User",
      "UserGroup",
      "UserNotification",
      "UserNotificationSuppression",
      "VehicleData",
      "VoiceLog",
      "Watchlist",
      "Widget"
    ],
    "NotifiableInterface": [
      "Scenario",
      "ScenarioCategory"
    ],
    "PermissableInterface": [
      "Scenario",
      "ScenarioCategory"
    ],
    "ScenarioOrCategoryNotificationInterface": [
      "ScenarioCategoryNotification",
      "ScenarioNotification"
    ],
    "TemplateInterface": [
      "CallTemplate",
      "EmailTemplate",
      "SmsTemplate"
    ],
    "TemplateType": [
      "CallTemplate",
      "EmailTemplate",
      "SmsTemplate"
    ],
    "Translated": [
      "CallTemplate",
      "EmailTemplate",
      "FieldOption",
      "FormField",
      "Instruction",
      "Scenario",
      "ScenarioCategory",
      "SmsTemplate",
      "Status",
      "TaskTemplate"
    ],
    "Translation": [
      "CallTemplateTranslation",
      "EmailTemplateTranslation",
      "FieldOptionTranslation",
      "FormFieldTranslation",
      "InstructionTranslation",
      "ScenarioCategoryTranslation",
      "ScenarioTranslation",
      "SmsTemplateTranslation",
      "StatusTranslation",
      "TaskTemplateTranslation"
    ],
    "UserGroupPermissionInterface": [
      "ScenarioCategoryUserGroupPermission",
      "ScenarioUserGroupPermission"
    ],
    "UserPermissionInterface": [
      "ScenarioCategoryUserPermission",
      "ScenarioUserPermission"
    ]
  }
};
      export default result;
    